import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

// Define the shape of the context
interface LoginContextType {
  redirectToLogin: (params: {redirectTo?: string}) => void
  handleLogin: (userData: any) => void
  handleLogout: () => void
  goBackAfterLogin: () => void
}

// Provide a default value to avoid the error
const LoginContext = createContext<LoginContextType | undefined>(undefined)

// Define props type for LoginProvider
interface LoginProviderProps {
  services: Services
  children: ReactNode 
}

export const LoginProvider: React.FC<LoginProviderProps> = ({ children, services }) => {
  const [redirectionPath, setRedirectionPath] = useState('/')
  // const [isAuthenticated, setIsAuthenticated] = useState(false)
  // const [session, setSession] = useState<CurrentSession>()

  // useEffect(() => {
  //   const id = services.session.listen((current) => {
  //     setSession(current)
  //   })
  //   return () => {
  //     services.session.remove(id)
  //   }
  // }, [])

  const navigate = useNavigate()
  const location = useLocation()

  const redirectToLogin = ({redirectTo = location.pathname}: {redirectTo?: string}) => {
    setRedirectionPath(redirectTo)
    navigate('/login')
  }

  const handleLogin = (userData: any) => {
    // setIsAuthenticated(true)
    navigate(redirectionPath)
  }

  const handleLogout = () => {
    setRedirectionPath('/')
    navigate('/logout')
  }

  const goBackAfterLogin = () => {
    const path = redirectionPath
    setRedirectionPath('/')
    navigate(path)
  }

  return (
    <LoginContext.Provider
      value={{ redirectToLogin, handleLogin, handleLogout, goBackAfterLogin }}
    >
      {children}
    </LoginContext.Provider>
  )
}

export const useLogin = (): LoginContextType => {
  const context = useContext(LoginContext)
  if (!context) {
    throw new Error('useLogin must be used within a LoginProvider')
  }
  return context
}
